var _style, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download-left_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 689.6,
    cy: 890.9,
    r: 32.6,
    fill: "#35a4dd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f9af17",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M987.8 495.5H320.3m200 214.9L319.5 495.5m200.8-214.9L319.5 495.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M689.6 629.2v166.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#35a4dd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 65,
    d: "M689.6 361V100.5H36.2v790.4h566.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLeft);
export default ForwardRef;